/** Standardized labels the website shows for every order type's status; each value is its label key under `orderDisplay.statusLabels`. */
export const STATUS_LABEL = {
  placing: "placing",
  created: "created",
  processing: "processing",
  shipped: "shipped",
  delivered: "delivered",
  readyForPickup: "readyForPickup",
  pickedUp: "pickedUp",
  cancelled: "cancelled",
  rejected: "rejected",
  problem: "problem",
  creationFailed: "creationFailed",
} as const;

export type StatusLabel = (typeof STATUS_LABEL)[keyof typeof STATUS_LABEL];

/** Each value is its label key under `orderDisplay.orderTypes`. */
export const ORDER_TYPE = {
  teamPurchaseUpgrade: "teamPurchaseUpgrade",
  lifeCycleReplacement: "lifeCycleReplacement",
} as const;

export type OrderType = (typeof ORDER_TYPE)[keyof typeof ORDER_TYPE];

/** Each value is its label key under `orderDisplay.deliveryMethods`. */
export const ORDER_DELIVERY_METHOD = {
  ship: "ship",
  pickup: "pickup",
} as const;

export type OrderDeliveryMethod =
  (typeof ORDER_DELIVERY_METHOD)[keyof typeof ORDER_DELIVERY_METHOD];
